import Input from 'tailwind-components/Input/Input';
import InputWithCopyButton from 'components/InputWithCopyButton/InputWithCopyButton';
import React from 'react';
import style from './residentForm.module.scss';
import propTypes from 'prop-types';

const STATES_WITHOUT_EXPIRATION = new Set([
  'Florida',
  'Maine',
  'Michigan',
  'North Carolina'
]);

function hasExpiration(state) {
  if (!state) return true;
  return !STATES_WITHOUT_EXPIRATION.has(state);
}

// read-only: the upload button that used to sit here pointed at the wrong zoho form
function ResidentForm({ user = {} }) {
  return (
    <div className={style.residentForm}>
      <>
        <Input
          label='State:'
          value={
            user.Resident_Insurance_License_State
              ? user.Resident_Insurance_License_State
              : ''
          }
          placeholder='-'
          lightLabel
          disabled
        />
        <InputWithCopyButton
          label='Licence Number:'
          value={
            user.License_Resident_Insurance_Number
              ? user.License_Resident_Insurance_Number
              : ''
          }
          placeholder='-'
          lightLabel
          disabled
          noSpacing
        />
        {hasExpiration(user.Resident_Insurance_License_State) && (
          <Input
            label='Expiration date:'
            value={
              user.Resident_Insurance_License_Expiration_Date
                ? user.Resident_Insurance_License_Expiration_Date
                : ''
            }
            placeholder='-'
            lightLabel
            disabled
          />
        )}
      </>
    </div>
  );
}

ResidentForm.propTypes = {
  user: propTypes.object
};

export default ResidentForm;
